<div class="modal fade" :id="modalComponentId" tabindex="-1" role="dialog" :aria-labelledby="modalComponentId + 'Label'" aria-hidden="true">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" :id="modalComponentId + 'Label'">{{modalHeading}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="onModalCloseClick">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <button class="btn btn-link w-100" v-if="selectedCompany.enableDeliveryOrders" @click="navigateToDeliveryOrders">
                    View Delivery Orders
                </button>
                <button class="btn btn-link w-100" v-if="selectedCompany.enableCollectionOrders" @click="navigateToCollectionOrders">
                    View Collection Orders
                </button>
                <button class="btn btn-link w-100" v-if="selectedCompany.enableExTankOrders" @click="navigateToExTankOrders">
                    View Ex-Tank Orders
                </button>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="onModalCloseClick">CLOSE</button>
            </div>
        </div>
    </div>
</div>